export default __webpack_public_path__ + "static/media/duo-violino-e-piano.e99cc40f.wav";